(function ($) {
  'use strict';

  $(function () {
    var $tocLinks = $('.policy-toc__item a');
    if (!$tocLinks.length) return;

    var sections = [];
    $tocLinks.each(function () {
      var id = $(this).attr('href').replace('#', '');
      var el = document.getElementById(id);
      if (el) sections.push({ id: id, el: el, $link: $(this) });
    });
    if (!sections.length) return;

    var activeId = null;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var matched = sections.find(function (s) { return s.el === entry.target; });
          if (matched && matched.id !== activeId) {
            activeId = matched.id;
            $tocLinks.removeClass('active');
            matched.$link.addClass('active');
          }
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });

    sections.forEach(function (s) { observer.observe(s.el); });
  });
})(jQuery);
